/**
 * Created by sarimj on 2/1/2016.
 */
/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import {ITeamInvitationService} from "@common/service/team.invitation.service";
import {ICachingService} from "@common/service/caching.service";
import {Util} from "@common/util";
import {INVITATION_STATUS, MEMBER_STATUS, PermissionsEnum, TargetEnum} from "@common/model/subject";
import _ from "lodash";

// typescript namespace
export class MemberProfileController {

    static $inject = ["$q", "$filter", "addInst", "showInvite", "CommonService", "$uibModal", "CacheService", "$http", "$timeout",
        "PopUpService", "$state", "baseUrl", "ApiAdapterService", "$rootScope", "memberProfile", "mode", "subject",
        "$uibModalInstance", "$validation", "TeamInvitationService", "CachingService", "moment", "PermissionService"];

    constructor($q, $filter, addInst, showInvite, CommonService, $uibModal, CacheService, $http, $timeout, PopUpService, $state,
                baseUrl, ApiAdapterService, $rootScope, memberProfile, mode, subject, $uibModalInstance, $validation,
                $_teamInvitation: ITeamInvitationService, private $_caching: ICachingService,
                moment, PermissionService) {
        var myMemberVm: any = this;
        if (!subject) {
            subject = CacheService.getCurrentSubject();
        }


        myMemberVm.init = () => {
            myMemberVm.mode = mode || 'view';
            $rootScope.mainShowLoader = false;
            myMemberVm.showInvite = showInvite;
            myMemberVm.memberProfileCopy = angular.copy(memberProfile);
            myMemberVm.memberProfile = memberProfile;
            myMemberVm.hasValidEmail = (memberProfile.providerIdentity != undefined || memberProfile.providerIdentity != null) ? true : false;
            myMemberVm.enableInviteBtn = false;
            myMemberVm.enableSaveBtn = true;
            myMemberVm.providerIdentityEmpty = !!memberProfile.providerIdentity;
            myMemberVm.addEmail = false;
            myMemberVm.currentUserId = CacheService.getUser().id;
            myMemberVm.states = Util.getStateList();
            myMemberVm.professions = Util.getProfessionList();
            myMemberVm.subject = subject;
            myMemberVm.user = CacheService.getUser();
            myMemberVm.userOwnedSubjects = [];
            myMemberVm.providerIdentityReadOnly = true;
            myMemberVm.providerIdentityBckup = memberProfile.providerIdentity;
            myMemberVm.noRecordsFound = Util.NO_MATCH_UISELECT;
            myMemberVm.copyTooltipText = 'Copy email';
            myMemberVm.copyTooltip = angular.copy(myMemberVm.copyTooltipText);


            if (!memberProfile.invitationStatus) {
                myMemberVm.enableInviteBtn = true;
            } else {
                if (memberProfile.invitationStatus == INVITATION_STATUS.EXPIRED_INVITE || memberProfile.invitationStatus == INVITATION_STATUS.RESEND_INVITE) {
                    myMemberVm.enableInviteBtn = true;
                } else {
                    myMemberVm.enableInviteBtn = false;
                }
            }
            myMemberVm.setNewPermissionFlags()
            if (mode == 'edit') {
                myMemberVm.enableEditMode();
            }


            if (myMemberVm.user.ownedSubjects) {
                myMemberVm.userOwnedSubjects = myMemberVm.user.ownedSubjects.split(",")
            }


            myMemberVm.memberProfile.contact = Util.formatPhone(myMemberVm.memberProfile.contact, "INTERNATIONAL");

            if (myMemberVm.mode == 'view') {
                ApiAdapterService.reloadTeamMember(myMemberVm.subject.subjectId, myMemberVm.memberProfile.id).then((s) => {
                    myMemberVm.memberProfile.invitation = s.invitation;
                });
            }
        }
        myMemberVm.setNewPermissionFlags = () => {
            PermissionService.isActionAllowed(myMemberVm.subject.teamPartyId, TargetEnum.TEAMMEMBER, PermissionsEnum.CREATE).then((isPermited) => {
                myMemberVm.isInvitePermited = isPermited
            })
        }

        myMemberVm.checkEmail = (form?) => {
            ApiAdapterService.checkEmlExists(myMemberVm.memberProfile.providerIdentity).then(s => {
                myMemberVm.memberProfile.firstName = s.firstName;
                myMemberVm.memberProfile.lastName = s.lastName;
                myMemberVm.disableNameFld = true;
            }, (e) => {
                myMemberVm.disableNameFld = false;
            }).finally(() => {
                (!!form) && myMemberVm.changeBtnStatus(form);
                myMemberVm.inviteLoader = false;
            });
        }
        // enable edit mode for Team Member
        myMemberVm.enableEditMode = () => {
            myMemberVm.mode = 'edit';
            if (!myMemberVm.memberProfile.isActive
                && myMemberVm.memberProfile.providerStatus != (MEMBER_STATUS.INVITED | MEMBER_STATUS.FORMER)) {
                myMemberVm.providerIdentityReadOnly = false;
            }
            myMemberVm.inviteLoader = true;
            myMemberVm.checkEmail();
        }

        myMemberVm.isOwner = () => {
            if (myMemberVm.currentUserId == myMemberVm.subject.ownerId) {
                return true;
            } else {
                return false;
            }
        }

        myMemberVm.init();

        myMemberVm.genderList = Util.getGenderList();

        myMemberVm.findState = (stateId) => {
            var state = myMemberVm.states.find(o => o['id'] == stateId);
            if (!!state)
                return state.name;
        };

        myMemberVm.validateEmail = function (email) {
            if (!!email) {
                return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
            } else {
                return false;
            }
        }

        myMemberVm.changeBtnStatus = function (form) {
            if (myMemberVm.providerIdentityBckup != form.teamemail.$viewValue || _.includes([INVITATION_STATUS.ADDED, INVITATION_STATUS.EXPIRED_INVITE], myMemberVm.memberProfile.invitationStatus)) {
                myMemberVm.enableInviteBtn = true;
            } else {
                myMemberVm.enableInviteBtn = false;
            }
            myMemberVm.enableSaveBtn = true;
        }

        myMemberVm.disableInviteButton = function () {
            myMemberVm.enableInviteBtn = false;
            myMemberVm.enableSaveBtn = false;
        }

        //enable invite button if email adrress is valid(edit mode)
        myMemberVm.enableInviteButton = function (form) {
            myMemberVm.hasValidEmail = myMemberVm.validateEmail(myMemberVm.memberProfile.providerIdentity);
            if (memberProfile.invitationStatus != INVITATION_STATUS.ACTIVE) {
                if (!!myMemberVm.hasValidEmail && myMemberVm.latestPId != myMemberVm.memberProfile.providerIdentity) {
                    myMemberVm.latestPId = myMemberVm.memberProfile.providerIdentity;
                    myMemberVm.inviteLoader = "Searching for user...";
                    myMemberVm.checkEmail(form);
                } else if (myMemberVm.latestPId == myMemberVm.memberProfile.providerIdentity) {
                    myMemberVm.changeBtnStatus(form);
                }
            }
        }

        myMemberVm.validate = (email) => {
            if (!!email) {
                myMemberVm.profileReadOnly = false;
                // myMemberVm.disableEmailLoader = true;
                //$rootScope.mainShowLoader = true;
                myMemberVm.inviteLoader = "Validating Email";
                ApiAdapterService.getUserByEmail(email, subject.subjectId).then((s) => {
                    console.log(s);
                    myMemberVm.memberProfile = s;
                    //$rootScope.mainShowLoader = false;
                    myMemberVm.inviteLoader = false;
                    myMemberVm.profileReadOnly = true;
                    // myMemberVm.disableEmailLoader = false;

                }, (e) => {
                    // $rootScope.mainShowLoader = false;
                    myMemberVm.inviteLoader = false;
                    //myMemberVm.memberProfile = new model.User().deserialize({ providerIdentity: myMemberVm.memberProfile.providerIdentity });
                    myMemberVm.memberProfile.photo = null;
                    myMemberVm.memberProfile.photoMimeType = null;
                    myMemberVm.profileReadOnly = false;
                })
            }

        }


        myMemberVm.inviteMemberProfile = (form) => {
            var inviteMember = () => {
                myMemberVm.inviteLoader = "Adding User To Team..";
                ApiAdapterService.createInactiveTeamMember(myMemberVm.memberProfile, subject.subjectId).then(
                    (s) => {
                        var _subjectId = subject.subjectId;
                        if (!myMemberVm.validateEmail(myMemberVm.memberProfile.providerIdentity)) {
                            PopUpService.openInformationModal('Invalid Email Address');
                            //myMemberVm.closeMemberProfile({ "message": 'Invalid Email Address', "status": false }, true);
                        }

                        myMemberVm._sendInvite(subject, myMemberVm.memberProfile, true, true);
                    },
                    (e) => {
                        myMemberVm.inviteLoader = false;
                        PopUpService.openInformationModal(e);
                        //myMemberVm.closeMemberProfile({ "message": e, "status": false }, true);
                    }

                );
            }
            $validation.validate(form)
                .success(inviteMember)
                .error(function (message) { console.log("Validation Error:", message) });
        }



        myMemberVm.sendInvite = (form, onlyInvite?, closePopup?) => {
            //if (myMemberVm.isOwner()) {
            if (myMemberVm.mode == 'edit') {
                return myMemberVm.updateMemberProfile(form, true);
            } else {
                return myMemberVm._sendInvite(subject, myMemberVm.memberProfile, onlyInvite, closePopup);
            }
        }



        myMemberVm._sendInvite = (subject, user) => {
            var deferred = $q.defer();
            let inviteCancelInfo = null;
            if (user.invitationStatus > INVITATION_STATUS.ACTIVE) {
                let updatedEmail = user.providerIdentity;
                let originalEmail = myMemberVm.memberProfileCopy.providerIdentity;
                if (updatedEmail != originalEmail) {
                    inviteCancelInfo = "Note: " + Util.OLD_INVITE_CANCEL_MSG;
                }
            }
            $_teamInvitation.inviteTeamMember(user, subject, null, inviteCancelInfo).then(
                (s) => {
                    if (s !== Util.DO_IT_LATER) {
                        //toastr.success(Util.INVITATION_SENT_SUCCESSFULLY, "");
                    }
                    $uibModalInstance.close({"user": user, "status": true});
                    deferred.resolve();
                }, (e) => {
                    console.log(e);
                    $uibModalInstance.close({"message": e, "status": false});
                    deferred.reject();
                });
            return deferred.promise;
        }

        myMemberVm.createMemberProfile = (form, invite?) => {
            var addMember = (d) => {

                var _subjectId = subject.subjectId;
                var subjType = "Project";
                if (subject.subjectTypeId == "INDIVIDUAL") {
                    subjType = "care recipient's";
                }
                var successMsg = "The Team Member has been saved (but not invited) to the " + subjType + " Team";

                if (invite) {
                    if (!myMemberVm.validateEmail(myMemberVm.memberProfile.providerIdentity)) {
                        PopUpService.openInformationModal('Invalid Email Address');
                        $timeout(() => {
                            d.reject();
                        }, 1000);
                        return d.promise;
                    }
                }

                if (myMemberVm.memberProfile.zip && (myMemberVm.memberProfile.zip.length > 5 || myMemberVm.memberProfile.zip.length < 5)) {
                    PopUpService.openInformationModal('Zip code is invalid.');
                    $timeout(() => {
                        d.reject();
                    }, 1000);
                    return d.promise;
                }

                myMemberVm.inviteLoader = "Creating Team Member";
                ApiAdapterService.createInactiveTeamMember(myMemberVm.memberProfile, _subjectId).then(
                    (s) => {
                        myMemberVm.memberProfile = s;
                        if (invite == true) {
                            myMemberVm._sendInvite(subject, s, true, true).finally(() => {
                                d.resolve();
                            });
                        } else {
                            if (!myMemberVm.memberProfile.providerIdentity) {
                                $rootScope.inviteLoader = false;
                                //$uibModalInstance.close({"user": s});
                                var title = "Yay, information saved! Time to add an email and invite";
                                $_teamInvitation.inviteTeamMember(myMemberVm.memberProfile, subject, title).then(
                                    (s) => {
                                        $uibModalInstance.close({"user": s});
                                        $rootScope.mainShowLoader = false;
                                        d.resolve();
                                    }, (e) => {
                                        console.log(e);
                                        $uibModalInstance.close({"user": s});
                                        $rootScope.mainShowLoader = false;
                                        d.reject();
                                    });
                            } else {
                                myMemberVm.inviteLoader = false;
                                PopUpService.openInformationModal(successMsg);
                                $uibModalInstance.close({"user": s});
                                d.reject();
                            }
                        }
                    },
                    (e) => {
                        myMemberVm.inviteLoader = false;
                        PopUpService.openInformationModal(e);
                        d.reject();
                    }
                )
            }
            var deferred = $q.defer();
            if (invite && !myMemberVm.memberProfile.providerIdentity) {
                PopUpService.openInformationModal('Email address is required to invite a Team Member.');
                $timeout(() => {
                    deferred.reject();
                }, 1000);
                return deferred.promise;
            }
            console.log('validating form', form);
            $validation.validate(form)
                .success(() => {
                    addMember(deferred);
                })
                .error(function (message) {
                    console.log("Validation Error:", message);
                    $timeout(() => {
                        deferred.reject();
                    }, 1000);
                });
            return deferred.promise;
        }

        myMemberVm.updateMemberProfile = (form, invite?) => {
            var _updateMemberProfile = (deferred) => {
                var _subjectId = subject.subjectId;
                var subjType = "Project";
                if (subject.subjectTypeId == "INDIVIDUAL") {
                    subjType = "Care Recipient's";
                }
                var successMsg = Util.UPDATE_TEAM_MEMBER.replace('$subjectType', subjType);

                if (invite) {
                    if (!myMemberVm.validateEmail(myMemberVm.memberProfile.providerIdentity)) {
                        PopUpService.openInformationModal('Invalid Email Address');
                        $timeout(() => {
                            deferred.reject();
                        }, 1000);
                        return deferred.promise;
                    }
                }

                if (myMemberVm.memberProfile.zip && (myMemberVm.memberProfile.zip.length > 5 || myMemberVm.memberProfile.zip.length < 5)) {
                    PopUpService.openInformationModal('Zip code is invalid.');
                    $timeout(() => {
                        deferred.reject();
                    }, 1000);
                    return deferred.promise;
                }

                myMemberVm.inviteLoader = "Updating Information";
                ApiAdapterService.updateTeamMember(myMemberVm.memberProfile, _subjectId, CacheService.getPassword(), invite).then(
                    (s) => {
                        myMemberVm.memberProfile.deserialize(s);
                        if (s.id == myMemberVm.currentUserId) {
                            if (!!s.photo) {
                                myMemberVm.user.photo = s.photo;
                                CacheService.setUser(myMemberVm.user);
                                $_caching.addOrUpdateUsers([myMemberVm.user]);
                            }
                        }
                        $_caching.addOrUpdateUsers([myMemberVm.memberProfile]);
                        myMemberVm.inviteLoader = false;
                        if (!!invite) {
                            myMemberVm._sendInvite(subject, myMemberVm.memberProfile, true, true).finally(() => {
                                deferred.resolve();
                            })
                        } else {
                            myMemberVm.inviteLoader = false;
                            $uibModalInstance.close({"user": s});
                            if (myMemberVm.memberProfile.invitationStatus > INVITATION_STATUS.ACTIVE) {
                                let updatedEmail = myMemberVm.memberProfile.providerIdentity;
                                let originalEmail = myMemberVm.memberProfileCopy.providerIdentity;
                                if (updatedEmail == originalEmail) {
                                    toastr.success(successMsg);
                                } else {
                                    PopUpService.openInformationModal(Util.OLD_INVITE_CANCEL_MSG).then(
                                        (s) => {
                                            toastr.success(successMsg);
                                        }
                                    );

                                }
                            } else {
                                toastr.success(successMsg);
                            }
                            deferred.resolve();
                        }
                    },
                    (e) => {
                        myMemberVm.inviteLoader = false;
                        PopUpService.openInformationModal(e);
                        deferred.reject();
                    });
                return deferred.promise;
            }
            var deferred = $q.defer();
            if (invite && !myMemberVm.memberProfile.providerIdentity) {
                PopUpService.openInformationModal('Email address is required to invite a Team Member.');
                $timeout(() => {
                    deferred.reject();
                }, 1000);
                return deferred.promise;
            }
            console.log('validating form', form);
            let ppp = angular.element('#phone').intlTelInput("getNumber");
            myMemberVm.memberProfile.contact = ppp;
            $validation.validate(form)
                .success(() => {
                    _updateMemberProfile(deferred);
                })
                .error(function (message) {
                    console.log("Validation Error:", message)
                    $timeout(() => {
                        deferred.reject();
                    }, 1000);
                });
            return deferred.promise;
        }

        // process suggestion
        myMemberVm.processSuggestion = (user, subject, process) => {
            $rootScope.mainShowLoader = true;
            $_teamInvitation.processSuggestion(subject, user, process).then((s) => {
                $rootScope.mainShowLoader = false;
                $uibModalInstance.close("suggestionProcessed");
            }, (e) => {
                console.log('error while processing suggestions');
                $uibModalInstance.dismiss();
            })
        }

        myMemberVm.closeMemberProfile = (obj, isError?) => {
            //
            // if (  myMemberVm.mode != 'view' && obj == 'fromHtml' ) {
            //   myMemberVm.mode = 'view';
            //   return;
            // }
            console.log('closing member profile', obj, isError);
            //if (!obj) {
            angular.copy(myMemberVm.memberProfileCopy, myMemberVm.memberProfile);
            $uibModalInstance.dismiss();
            //}


            // if (!!isError) {
            //     PopUpService.openInformationModal(obj.message);
            // } else {
            //     $uibModalInstance.close(obj);
            // }

        };

        if (!!addInst) {
            addInst.close(subject);
        }

        myMemberVm.copySuccessCallback = () => {
            myMemberVm.copyTooltip = "Successfully copied to clipboard";
            $timeout(() => {
                myMemberVm.copyTooltip = angular.copy(myMemberVm.copyTooltipText);
            }, 5000);

        }
    }
}

angular.module('eCareVault.common.popUp')
    .controller('MemberProfileController', MemberProfileController);
